import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareDoNotBleachIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.318 2.384a.754.754 0 0 1 1.314 0l4.424 7.84 3.881-1.44a.996.996 0 0 1 1.28.586l.175.473-4.59 1.703 1.946 3.45 3.55 1.316c.518.193.781.77.59 1.288l-.174.467-2.824-1.048 1.897 3.362a.747.747 0 0 1-.65 1.114H1.817a.749.749 0 0 1-.653-1.116l1.896-3.36-2.824 1.048-.173-.467a1.002 1.002 0 0 1 .591-1.288l3.547-1.317 1.947-3.449-4.59-1.703.173-.468a1.001 1.001 0 0 1 1.287-.59l3.876 1.44Zm.657 11.326-6.736 2.5-2.136 3.785h17.744l-2.136-3.785-6.736-2.5Zm4.403-1.635-2.248.834 3.44 1.277-1.192-2.11Zm-8.806 0L6.38 14.186l3.44-1.277-2.248-.834Zm4.403-7.804L8.32 10.752l3.656 1.357 3.657-1.357-3.657-6.48Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { productCareDoNotBleachIcon as default };
//# sourceMappingURL=productCareDoNotBleachIcon.js.map
